import React from 'react'
import PageTitle from './PageTitle'
import './css/Style.min.css'
import './css/Responsive.min.css'

export default function Portfolio() {
    function PortfolioCard(props) {
        return (
            <div className="portfolio_card">
                <a href={props.livelink} target="_blank">
                    <div className="title">
                        <h4>{props.projectname}</h4>
                    </div>
                </a>
            </div>
        )
    }
    return (
        <section id="porfolio">
            <div className="container">
                <div className="row">
                    <div className="col-lg-12">
                        <PageTitle Pageinfo="works" Pagename="My" Highlight="portfolio" />
                    </div>
                </div>
                <div className="row">
                    <div className="col-lg-4 col-md-6">
                        <PortfolioCard projectname="Waxom" livelink="https://iftekhar-hossen.github.io/waxom/" />
                    </div>
                    <div className="col-lg-4 col-md-6">
                        <PortfolioCard projectname="Github User Details" livelink="https://iftekhar-hossen.github.io/github-finder/" />
                    </div>
                    <div className="col-lg-4 col-md-6">
                        <PortfolioCard projectname="Marvinwalter" livelink="https://iftekhar-hossen.github.io/marvinwalter/" />
                    </div>
                    <div className="col-lg-4 col-md-6">
                        <PortfolioCard projectname="Internet Speed Test" livelink="https://iftekhar-hossen.github.io/internet-speed-test/" />
                    </div>
                    <div className="col-lg-4 col-md-6">
                        <PortfolioCard projectname="Mogo" livelink="https://iftekhar-hossen.github.io/internet-speed-test/" />
                    </div>
                    <div className="col-lg-4 col-md-6">
                        <PortfolioCard projectname="Hunt" livelink="https://iftekhar-hossen.github.io/hunt/" />
                    </div>
                </div>
            </div>
        </section>
    )
}
